import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Layout, Typography, Space, Dropdown, Avatar } from "antd";
import {
  LogoutOutlined,
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useUser } from "../context/UserContext";
import Sidebar from "../components/layout/Sidebar";
import { useCommon } from "../context/CommonContext";
const { Header } = Layout;
const { Text } = Typography;

const GlobalLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useUser();
  const [collapsed, setCollapsed] = useState(false);
  const { pageTitle } = useCommon();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const userMenuItems = [
    // {
    //   key: "profile",
    //   icon: <UserOutlined />,
    //   label: "Profile",
    //   onClick: () => {
    //     // TODO: Navigate to profile page
    //     console.log("Navigate to profile");
    //   },
    // },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Sidebar
        collapsed={collapsed}
        onCollapse={() => setCollapsed(!collapsed)}
      />
      <Layout
        className={`${
          collapsed ? "ml-20" : "ml-64"
        } transition-all duration-200`}
      >
        <Header
          className={`fixed top-0 right-0 left-0 z-[1000] bg-white px-6 ${
            collapsed ? "ml-20" : "ml-64"
          }`}
        >
          <div className="flex items-center justify-between">
            <Space>
              {collapsed ? (
                <MenuUnfoldOutlined
                  className="text-xl text-gray-600 cursor-pointer"
                  onClick={() => setCollapsed(!collapsed)}
                />
              ) : (
                <MenuFoldOutlined
                  className="text-xl text-gray-600 cursor-pointer"
                  onClick={() => setCollapsed(!collapsed)}
                />
              )}

              <Text className="text-2xl font-medium">{pageTitle}</Text>
            </Space>

            <Space>
              <Text>Welcome, {user?.name || "User"}</Text>
              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                arrow
              >
                <Avatar icon={<UserOutlined />} style={{ cursor: "pointer" }} />
              </Dropdown>
            </Space>
          </div>
        </Header>
        <div className="mt-16">
          <Outlet />
        </div>
      </Layout>
    </Layout>
  );
};

export default GlobalLayout;
